import { FC, useRef, memo } from 'react';
import clsx from 'clsx';
import { StreamApp, FlatFeed, Streami18n } from 'react-activity-feed';

import Activity from '../Activity';
import ErrorBoundary from '../ErrorBoundary';
import ProfilePaginator from '../ProfilePaginator';
import Placeholder from '../Placeholder';
import ProfileHeader from '../ProfileHeader';
import Post from '../Post';

import { State, UserIds } from '../../../types/feed';

import styles from './LocalUser.module.css';

export type Props = {
  state: State;
  apiKey: string;
  appId: string;
  onSendMessage: () => void;
  allowPost: boolean;
};

const i18n = new Streami18n({
  language: 'en',
});

export const LocalUserComponent: FC<Props> = ({
  appId,
  apiKey,
  onSendMessage,
  state,
  allowPost,
}) => {
  const handleError = (error: any) => {
    window.Sentry?.captureException(error);
  };

  const containerRef: any = useRef();

  return (
    <div
      className={clsx(styles.wrapper, {
        [styles.allowPost]: allowPost,
      })}
      ref={containerRef}
    >
      <ErrorBoundary>
        <StreamApp
          appId={appId}
          apiKey={apiKey}
          token={state?.[UserIds.Eric]?.userToken || ''}
          errorHandler={handleError}
          i18nInstance={i18n}
        >
          <ProfileHeader state={state} name={state?.[UserIds.Eric]?.name} />
          <FlatFeed
            feedGroup="user"
            notify
            Placeholder={Placeholder}
            Activity={({ activity }: any) => (
              <Activity repost={true} activity={activity} noFooter={false} />
            )}
            Paginator={(props) => (
              <ProfilePaginator {...props} containerRef={containerRef} />
            )}
          />
          {allowPost && <Post onSendMessage={onSendMessage} />}
        </StreamApp>
      </ErrorBoundary>
    </div>
  );
};
export const LocalUser = memo(LocalUserComponent);
